/**
 * Считает разницу в днях между переданной датой (формат 'YYYYMMDD')
 * и текущей датой (по локальному времени машины).
 * Время суток игнорируется, учитываются только календарные дни.
 */
export const calcDiffFromCurrentDate = (date: string): number => {
  let year = Number(date.substring(0, 4))
  let month = Number(date.substring(4, 6))
  let day = Number(date.substring(6, 8))

  // Создаём дату из полученных значений (месяц в Date с нуля, поэтому month - 1)
  const entryISODate = new Date(year, month - 1, day)

  // Текущая дата (используем локальное время)
  const currentDate = new Date()
  // Обнуляем время, чтобы считать только дни, без учёта часов/минут
  currentDate.setHours(0, 0, 0, 0)

  // Разница в миллисекундах между текущей датой и переданной
  const diffDates = Math.abs(currentDate.getTime() - entryISODate.getTime())
  // Переводим миллисекунды в дни и округляем до ближайшего целого
  const calcDays = Math.round(diffDates / (1000 * 60 * 60 * 24))

  // Возвращаем количество дней разницы
  return calcDays
}